import {
  userModules
} from '@r'
const actions = {
  REFRESH_USER_INFO({
    commit,
    state
  }) {
    userModules.getUserPersonalData({
      emulateJSON: true
    }).then(res => {
      commit('setUserInfo', res.mdata ? res.mdata.userData : null);
      state.enableAuthorityList = res.mdata ? res.mdata.enableAuthorityList : [];
    }).catch(e => console.log("aa"));
  }
}
export default actions;
